import * as angular from 'angular';
import * as ng from 'angular';
import { PK } from 'commons';
import { TradersYardApi } from '../../models/api';

export default (module: ng.IModule) => {
    module.component('tyEventCheckoutModal', {
        bindings: {
            close: '&',
            dismiss: '&',
            modalInstance: '=',
            resolve: '<',
        },
        template: require('./event-checkout-modal.html').default,
        controller: EventCheckoutModalCtrl,
    });
};

class EventCheckoutModalCtrl implements ng.IComponentController {
    static $inject = ['$http', '$window', '$timeout', '$socket'];
    private resolve: {
        eventId?: string;
        joinRequestId?: string;
    } = {};
    private order?: TradersYardApi.xYards.xYardsOrder = undefined;

    /**
     * Different views we can show in the modal. Kind of a router :)
     * @private
     */

    private view: 'start' | 'checkout' = 'start';
    /**
     * Flag indicating if we are waiting for some request to finish.
     * @private
     */
    private isLoading = false;

    constructor(private $http: ng.IHttpService) {}

    $onInit() {}

    startCheckout = () => {
        const { eventId, joinRequestId } = this.resolve;

        if (!eventId || !joinRequestId) {
            console.warn('Event or Join Request missing', eventId, joinRequestId);
            return;
        }

        this._wrapInLoading<TradersYardApi.xYards.xYardsOrder>(() => {
            return this._startCheckout(eventId, joinRequestId);
        }).then((orderData) => {
            this.order = orderData;
            this.view = 'checkout';
        });
    };

    _wrapInLoading<T>(cb: () => angular.IPromise<T>) {
        this.isLoading = true;
        return cb()
            .then()
            .finally(() => (this.isLoading = false));
    }

    private _startCheckout(eventId: PK, requestId: PK): ng.IPromise<TradersYardApi.xYards.xYardsOrder> {
        return this.$http
            .post<{ data: TradersYardApi.xYards.xYardsOrder }>(
                `/api/v1.0/webinar/${eventId}/request/${requestId}/checkout`,
                {}
            )
            .then((res) => res.data.data);
    }
}
